module.exports = __webpack_public_path__ + "static/10-bb3d8d1c70301925c4988a891a90e8f9.jpg";